import { FORM_SUBMIT } from './types'

export const formSubmited = data => dispatch =>
  dispatch({
    type: FORM_SUBMIT,
    payload: { submited: true, message: data.message }
  })
